var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCopy(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2052_6405)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.66602 13.3337V15.667C6.66602 16.6004 6.66602 17.0671 6.84767 17.4236C7.00746 17.7372 7.26243 17.9922 7.57603 18.152C7.93255 18.3337 8.39926 18.3337 9.33268 18.3337H15.666C16.5994 18.3337 17.0661 18.3337 17.4227 18.152C17.7363 17.9922 17.9912 17.7372 18.151 17.4236C18.3327 17.0671 18.3327 16.6004 18.3327 15.667V9.33366C18.3327 8.40024 18.3327 7.93353 18.151 7.57701C17.9912 7.2634 17.7363 7.00844 17.4227 6.84865C17.0661 6.66699 16.5994 6.66699 15.666 6.66699H13.3327M4.33268 13.3337H10.666C11.5994 13.3337 12.0661 13.3337 12.4227 13.152C12.7363 12.9922 12.9912 12.7372 13.151 12.4236C13.3327 12.0671 13.3327 11.6004 13.3327 10.667V4.33366C13.3327 3.40024 13.3327 2.93353 13.151 2.57701C12.9912 2.2634 12.7363 2.00844 12.4227 1.84865C12.0661 1.66699 11.5994 1.66699 10.666 1.66699H4.33268C3.39926 1.66699 2.93255 1.66699 2.57603 1.84865C2.26243 2.00844 2.00746 2.2634 1.84767 2.57701C1.66602 2.93353 1.66602 3.40024 1.66602 4.33366V10.667C1.66602 11.6004 1.66602 12.0671 1.84767 12.4236C2.00746 12.7372 2.26243 12.9922 2.57603 13.152C2.93255 13.3337 3.39926 13.3337 4.33268 13.3337Z",
    stroke: "#475467",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2052_6405"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCopy);
export default __webpack_public_path__ + "static/media/copy.f23432e2284f70e4b55bbc8602df335e.svg";
export { ForwardRef as ReactComponent };